<mat-toolbar class="ori-elevation-z4 header">
  <h3>{{ "settings.title" | translate }}</h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>
<div mat-dialog-content>
  <div class="set-item">
    {{ "settings.lang.label" | translate }}
    <o-select-lang></o-select-lang>
  </div>

  <div class="set-item">
    {{ "paginator.perpage" | translate }}
    <mat-form-field>
      <mat-select [(ngModel)]="store.userItemsPerPage" (selectionChange)="updateItemsPerPage($event.value)">
        @for (value of itemsPerPageValues; track $index) {
          <mat-option [value]="value">{{ value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (confService.isOnPrem) {
    <div class="set-item">
      {{ "settings.exportMaxZipSize.label" | translate }}
      <mat-form-field>
        <input
          matInput
          [(ngModel)]="store.exportMaxZipSize"
          [placeholder]="'settings.exportMaxZipSize.placeholder' | translate"
          type="number"
          min="1"
          (change)="updateExportMaxZipSize($event.target.value)" />
      </mat-form-field>
    </div>
  }

  <div class="set-item theme-selector">
    {{ "settings.theme.label" | translate }}
    <mat-slide-toggle [(ngModel)]="store.darkMode" (change)="changeTheme($event.checked)"></mat-slide-toggle>
  </div>

  @if (platformAllowed && store.pubInfo?.capabilities?.player3D) {
    <div class="set-item player-selector">
      {{ "settings.activate3D.label" | translate }}
      <mat-slide-toggle
        [(ngModel)]="store.userActivate3D"
        (change)="changeDisplayMode($event.checked)"></mat-slide-toggle>
    </div>
  }

  @if (store.syncSettings?.enable && store.pubInfo?.capabilities?.sync) {
    <div class="set-item">
      {{ "settings.autoSynchro.label" | translate }}
      <mat-slide-toggle
        [(ngModel)]="store.userAutoSynchro"
        (change)="toggleAutoSynchro($event.checked)"></mat-slide-toggle>
    </div>
  }

  <div class="set-item">
    {{ "settings.redirectLastDm.label" | translate }}
    <mat-slide-toggle
      [(ngModel)]="store.redirectLastDm"
      (change)="updateUserRedirectDm($event.checked)"></mat-slide-toggle>
  </div>

  @if (!hideDebugOption) {
    <div>
      <div class="set-item">
        Debug Mode
        <mat-slide-toggle [(ngModel)]="store.debugMode"></mat-slide-toggle>
      </div>
      <div class="set-item">
        Disable BP2
        <mat-slide-toggle [(ngModel)]="disableBP2"></mat-slide-toggle>
      </div>
      @if (store.pubInfo) {
        <div class="set-item">
          Change publication language
          <o-select-lang [changePubLang]="true"></o-select-lang>
        </div>
      }
    </div>
  }
</div>
